@if (procInst) {
  <div>
    @if (procInst.id) {
      <dl class="govuk-summary-list">
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Id</dt>
          <dd class="govuk-summary-list__value">{{procInst.id}}</dd>
          <!--dd class="govuk-summary-list__actions">
          <a class="govuk-link" href="#">
            Change<span class="govuk-visually-hidden"> name</span>
          </a>
        </dd-->
      </div>
      @if (procInst.name) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key"> Name </dt>
          <dd class="govuk-summary-list__value"> {{procInst.name}} </dd>
        </div>
      }
      @if (procInst.businessKey) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key"> Business key </dt>
          <dd class="govuk-summary-list__value"> {{procInst.businessKey}} </dd>
        </div>
      }
      @if (procInst.processDefinitionDescription) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key"> Process definition </dt>
          <dd class="govuk-summary-list__value">
            <button class="govuk-button" data-module="govuk-button" style="float:right"
              [routerLink]="['/proc-defs/proc-def-detail', procInst.processDefinitionId]">
              View details
            </button>
            <strong>
              {{procInst.processDefinitionName}}
              {{procInst.processDefinitionId.indexOf(':') === -1 ? '' : '(v'+procInst.processDefinitionId.split(':')[1]+')'}}
            </strong><br/>
            <span>{{procInst.processDefinitionDescription}}</span>
          </dd>
        </div>
      }
      @if (procInst.startUserId) {
        <div class="govuk-summary-list__row">
          <dt class="govuk-summary-list__key">Started by</dt>
          <dd class="govuk-summary-list__value"> {{procInst.startUserId}} </dd>
        </div>
      }
      <div class="govuk-summary-list__row">
        <dt class="govuk-summary-list__key">Timings</dt>
        <dd class="govuk-summary-list__value">
          @if (procInst.startTime) {
            <span>{{procInst.startTime | date:"dd MMM yy"}} {{procInst.startTime | date:"HH:mm"}} - </span>
          }
          @if (procInst.endTime) {
            <span>{{procInst.endTime | date:"dd MMM yy"}} {{procInst.endTime | date:"HH:mm"}}</span>
          }
          @if (procInst.durationInMillis) {
            <span> ({{procInst.durationInMillis | friendlyDuration}})</span>
          }
        </dd>
      </div>
    </dl>
  }
  <div class="govuk-tabs" data-module="govuk-tabs">
    <h2 class="govuk-tabs__title">
      Contents
    </h2>
    <ul class="govuk-tabs__list">
      <li class="govuk-tabs__list-item govuk-tabs__list-item--selected">
        <a class="govuk-tabs__tab"  [routerLink]="['/proc-insts/proc-inst-detail', procInst.id]" fragment="events"> Events </a>
      </li>
      <li class="govuk-tabs__list-item">
        <a class="govuk-tabs__tab" [routerLink]="['/proc-insts/proc-inst-detail', procInst.id]" fragment="data"> Data </a>
      </li>
    </ul>
    <div class="govuk-tabs__panel govuk-tabs__panel--hidden" id="events">
      <h2 class="govuk-heading-l">Events</h2>
      @if (activities && activities.length>0) {
        <table class="govuk-table">
          <thead class="govuk-table__head">
            <tr class="govuk-table__row">
              <th scope="col" class="govuk-table__header">Id</th>
              <th scope="col" class="govuk-table__header">What</th>
              <th scope="col" class="govuk-table__header">When</th>
              <th scope="col" class="govuk-table__header">Who</th>
              <th scope="col" class="govuk-table__header">Task</th>
              <th scope="col" class="govuk-table__header">Child instance</th>
            </tr>
          </thead>
          <tbody class="govuk-table__body">
            @for (activity of activities; track activity; let i = $index) {
              <tr class="govuk-table__row"
                [class.selected]="activity === selectedActivity">
                <th scope="row" class="govuk-table__header">{{i + 1}}</th>
                <td class="govuk-table__cell">{{ activity.activityName === null ? activity.activityId : activity.activityName }}</td>
                <td class="govuk-table__cell">{{ activity.startTime  | date:"dd MMM yy HH:mm" }} - <br/>{{ activity.endTime | date:"dd MMM yy HH:mm" }}</td>
                <td class="govuk-table__cell">{{ activity.assignee }}</td>
                <td class="govuk-table__cell">{{ activity.taskId }}</td>
                <td class="govuk-table__cell"><a [routerLink]="['/proc-insts/proc-inst-detail', activity.calledProcessInstanceId]">{{ activity.calledProcessInstanceId }}</a></td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (childInsts && childInsts.length>0) {
        <table class="govuk-table">
          <caption class="govuk-table__caption">Child instances</caption>
          <thead class="govuk-table__head">
            <tr class="govuk-table__row">
              <th scope="col" class="govuk-table__header">Id</th>
              <th scope="col" class="govuk-table__header">Business key</th>
              <th scope="col" class="govuk-table__header">Name</th>
            </tr>
          </thead>
          <tbody class="govuk-table__body">
            @for (childInst of childInsts; track childInst; let i = $index) {
              <tr class="govuk-table__row"
                [class.selected]="childInst === selectedChildInst">
                <th scope="row" class="govuk-table__header"><a [routerLink]="['/proc-insts/proc-inst-detail', childInst.id]">{{i}}</a></th>
                <td class="govuk-table__cell">{{childInst.businessKey}}</td>
                <td class="govuk-table__cell">{{childInst.processDefinitionName}}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
    <div class="govuk-tabs__panel" id="data">
      <h2 class="govuk-heading-l">Data</h2>
      @if (procInst.variables && procInst.variables.length>0) {
        <table class="govuk-table">
          <thead class="govuk-table__head">
            <tr class="govuk-table__row">
              <th scope="col" class="govuk-table__header">Name</th>
              <th scope="col" class="govuk-table__header">Type</th>
              <th scope="col" class="govuk-table__header">Value</th>
            </tr>
          </thead>
          <tbody class="govuk-table__body">
            @for (variable of procInst.variables; track variable; let i = $index) {
              <tr class="govuk-table__row"
                [class.selected]="variable === selectedVar">
                <th scope="row" class="govuk-table__header">{{variable.name}}</th>
                <td class="govuk-table__cell"> {{ variable.type }} </td>
                <td class="govuk-table__cell">
                  @switch (variable.type) {
                    @case ('boolean') {
                      <span>{{ variable.value ? 'Yes' : 'No' }}</span>
                    }
                    @case ('integer') {
                      <span>{{ variable.value }}</span>
                    }
                    @case ('json') {
                      <span>{{ variable.value | json }}</span>
                    }
                    @default {
                      <span>{{variable.value}}</span>
                    }
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div><!-- end tabs -->
  <div class="app-back-to-top" data-module="app-back-to-top">
    <a class="govuk-link govuk-link--no-visited-state app-back-to-top__link" href="#top">
      <svg role="presentation" focusable="false" class="app-back-to-top__icon" xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17">
        <path fill="currentColor" d="M6.5 0L0 6.5 1.4 8l4-4v12.7h2V4l4.3 4L13 6.4z"></path>
      </svg>Back to top
    </a>
  </div>
  <div class="govuk-button-group">
    <button class="govuk-button" data-module="govuk-button" [routerLink]="['/proc-insts']">
      Back to list
    </button>
    <button class="govuk-button govuk-button--warning" data-module="govuk-button" (click)="onDelete()">
      Delete instance
    </button>
  </div>
</div>
}
